<template>
  <BaseCard>
    <FlexLayout
      align="start"
      direction="column"
    >
      <AppLogo />
      <BaseText flush>
        Please log in to continue.
      </BaseText>
      <BaseButton @click="handleLogin">
        Log in
        <BaseIcon
          id="sign-in"
          inline
        />
      </BaseButton>
    </FlexLayout>
  </BaseCard>
</template>

<script setup lang="ts">
import AppLogo from '@components/common/AppLogo.vue';
import { useSessionStore } from '@stores/session';
import { useRouter } from 'vue-router';
const router = useRouter();
const sessionStore = useSessionStore();

const handleLogin = async () => {
  try {
    try {
      await sessionStore.fetchSession();
      router.push('/plans');
    } catch {
      window.location.reload(); // trigger server
    }
  } catch (error) {
    console.error('Login failed', error);
  }
};
</script>
